<template>
  <div class="container-fluid">
    <div class="col-sm-6">
      <div class="text-left">
        <h3>
          <router-link to="/agenda">Agenda</router-link> » {{crud === 'c'? 'Novo' : 'Alterando'}}
        </h3>
      </div>
      <div class="text-left">
        <h3>{{cliente.razao}}</h3>
        <span class="label label-default">{{cliente.fantasia}}</span><br>
        <cite>{{cliente.endereco}}</cite><br> 
        <span v-for="telefone in cliente.telefone">{{maskTelefone(telefone.numero)}}</span>
        <hr size=2>
        <div class="form">
          <div class="col-sm-4">
            <label for="">Data</label>
            <div class="input-group">
              <input :value="formatData(form.dt)" type="text" class="form-control" disabled>
              <div class="input-group-btn spancelendar">
                <button class="btn btn-primary" @click="showCalendar=true"><i class="glyphicon glyphicon-calendar"></i></button>
              </div>
              <Calendario v-if="showCalendar" @pickDate="setDate" class="calendario"></Calendario>
            </div>
          </div>
          <div class="col-sm-3">
            <label for="">Hora</label>
            <input v-model="form.hora" type="text" placeholder="08:00" max-length=5 class="form-control slim" @focusout="maskHora($event)" @keyup="maskHora($event)" @keydown="maskHora($event)">
          </div>
          <div class="col-sm-5">
            <label for="">Funcionário</label>
            <select v-model="form.codfuncionario" name="" id="" class="form-control">
              <option value="1" :selected="form.codfuncionario==='1'">Alguem</option>
              <option value="2" :selected="form.codfuncionario==='2'">Fabio</option>
              <option value="3" :selected="form.codfuncionario==='3'">Felipe</option>
              <option value="4" :selected="form.codfuncionario==='4'">Jair</option>
              <option value="5" :selected="form.codfuncionario==='5'">Josue</option>
              <option value="6" :selected="form.codfuncionario==='6'">Lucas</option>
              <option value="7" :selected="form.codfuncionario==='7'">Prado</option>
              <option value="8" :selected="form.codfuncionario==='8'">Regis</option>
              <option value="9" :selected="form.codfuncionario==='9'">Roberto</option>
              <option value="10" :selected="form.codfuncionario==='10'">Rodrigo</option>
              <option value="11" :selected="form.codfuncionario==='11'">Sanguine</option>
              <option value="12" :selected="form.codfuncionario==='12'">Valni</option>
            </select>
          </div>
          <div class="col-sm-12">
            <textarea ref="iptdescricao" v-model="form.descricao" name="" id="" cols="30" rows="10" class="form-control"></textarea>
          </div>
          <div class="col-sm-12 text-left">
            <button @click="remove()" v-if="form.cod" class="btn btn-danger">Excluir Compromisso</button>
            <button @click="save()" class="btn btn-success pull-right">Salvar Compromisso</button>
          </div>
        </div>
        <!-- Fim do form -->
      </div>
    </div>
    <div class="col-sm-6 text-left" v-if="form.dt">
      <h3>Compromissos para {{formatData(form.dt)}}</h3>
      <div v-for="compromisso in compromissos[form.dt]">
        <b>{{compromisso.hora}}</b> <cite>{{compromisso.razao}}</cite> ({{compromisso.funcionarionome}})<br>
        <p>{{compromisso.descricao}}</p>
        <hr>
      </div>
    </div>
  </div>
</template>

<script>
import Calendario from './Calendar.vue'
import Mask from './Mask.js'
import swal from 'sweetalert'

export default {
  name: '',
  components: {
    Calendario
  },
  data () {
    return {
      showCalendar: false,
      crud: undefined,
      form: {
        cod: 0,
        codcli: undefined,
        codfuncionario: '1',
        codautor: '1',
        descricao: '',
        dt: '',
        hora: '08:30',
        situacao: '',
        excluido: false
      },
      cliente: {},
      compromissos: {}
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/getagenda.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          this.fetchData(response.body)
        },
        function (error) {
          console.log(error)
        }
      )
    },
    loadAgendaDate (date) {
      const url = './api/php/getagenda.php'
      this.$http.post(url, JSON.stringify({'adate': date})).then(
        function (response) {
          this.compromissos = response.body
        },
        function (error) {
          console.log(error)
        }
      )
    },
    loadCliente (cod) {
      const url = './api/php/getcliente.php'
      this.$http.post(url, JSON.stringify({'cod': cod})).then(
        function (response) {
          // console.log(response.body)
          this.fetchDataCliente(response.body)
        },
        function (error) {
          console.log(error)
        }
      )
    },
    loadTarefas (cod) {
      const url = './api/php/gettarefa.php'
      this.$http.post(url, JSON.stringify({'codcli': cod})).then(
        function (response) {
          if (response.body.length > 0) {
            this.fetchDataTarefasPendentes(response.body)
          } else {
            console.log('Nenhuma tarefa para visita no HUB')
          }
        },
        function (error) {
          console.log(error)
        }
      )
    },
    save () {
      delete this.form['funcionarionome']
      const url = './api/php/addagenda.php'
      this.$http.post(url, JSON.stringify(this.form)).then(
        function (response) {
          console.log(response.body)
          if (this.crud === 'c') {
            swal('Agendado com sucesso', 'Compromisso agendado com ' + this.cliente.razao + ' para as ' + this.form.hora + ' do dia ' + this.formatData(this.form.dt), 'success')
          } else {
            swal('Alterado com Sucesso', '', 'success')
          }
          this.closeForm()
        },
        function (error) {
          console.log(error)
        }
      )
    },
    remove () {
      const cod = this.form.cod
      const url = './api/php/removeagenda.php'
      this.$http.post(url, JSON.stringify({'cod': cod})).then(
        function (response) {
          // console.log(response.body)
          swal('Excluído com sucesso', '', 'success')
          this.closeForm()
        },
        function (error) {
          console.log(error)
        }
      )
    },
    fetchData (o) {
      console.log('Try fetch data')
      this.form = o
      this.form.hora = Mask.hora(o.hora)
      this.loadCliente(this.form.codcli)
      this.loadAgendaDate(this.form.dt)
    },
    fetchDataCliente (o) {
      this.form.codcli = o.cod
      this.cliente = o
      let pfix = 'cob'
      if (o.endrua !== '') pfix = 'end'
      this.cliente['endereco'] = o[pfix + 'rua'] + ', ' + o[pfix + 'numero'] + ' ' + o[pfix + 'compl'] + '. ' + o[pfix + 'bairro'] + ' - ' + o[pfix + 'cidade'] + ' / ' + o[pfix + 'uf']
      this.loadTarefas(this.form.codcli)
    },
    fetchDataTarefasPendentes (o) {
      let txt = '\n\n'
      txt += '=====================\n'
      txt += 'TAREFAS PENDENTES HUB\n'
      txt += '=====================\n'
      o.forEach(function (tarefa) {
        txt += '[#' + tarefa.cod + '] ' + tarefa.descr + '\n--------------------\n'
      })
      txt += 'Avisar que concluiu alguma tarefa do hub.'
      this.form.descricao += txt
    },
    setDate (date) {
      this.form.dt = date
      this.showCalendar = false
      this.loadAgendaDate(date)
    },
    formatData (date) {
      if (date.length > 0) {
        return date.substring(6, 8) + '/' + date.substring(4, 6) + '/' + date.substring(0, 4)
      }
    },
    closeForm () {
      this.$router.go(-1)
    },
    maskHora (e) {
      e.target.value = Mask.hora(e.target.value)
    }
  },
  created: function () {
    const crud = this.$route.params.crud
    const cod = this.$route.params.id
    if (crud === 'c') {
      // Criar novo compromisso
      console.log('Criando novo compromisso')
      this.form.codautor = this.$root.cod
      this.loadCliente(cod)
      if (this.$root.globalAgeFormDt !== undefined) {
        this.setDate(this.$root.globalAgeFormDt)
        this.$root.globalAgeFormDt = undefined
      }
    } else if (crud === 'u') {
      // Altera um compromisso
      console.log('Alterando compromisso')
      this.load({'cod': cod})
    } else {
      console.log('CRUD INVÁLIDO NO ACESSO AO FORM')
    }
    this.crud = crud
    this.maskTelefone = Mask.telefone
    this.$nextTick(() => { this.$refs.iptdescricao.focus() })
  }
}
</script>

<style scoped>
  textarea {
    margin: 10px 10px 10px 0px;
  }
  input[type=text].slim {
    padding: 10px;
  }
  span.calendario {
    position: relative;
  }
  .calendario {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
  }
  @media (max-width: 499px) {
    .container-fluid {
      width: 100%;
      margin: 0px;
      padding: 0px;
    }
    .spancalendar {
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AgeForm.vue